import type { Styles } from 'common/types';

export const styles: Styles = {
  root: {
    position: 'relative',
    width: '100%',
    borderRadius: 2,
    border: '1px dashed',
    borderColor: 'divider',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'border-color 0.2s, background-color 0.2s',
  },
  dragOver: {
    borderColor: 'primary.main',
    backgroundColor: 'action.hover',
  },
  error: {
    borderColor: 'error.main',
  },
  dropArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    p: 1,
  },
  icon: {
    fontSize: 32,
  },
  media: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
};
